import * as React from "react";
export default function MultiLine(_a) {
    var text = _a.text;
    return (React.createElement("p", null, text.split("\n").map(function (t, i) {
        return (React.createElement("span", { key: i },
            t,
            React.createElement("br", null)));
    })));
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/multiLine/index.tsx
// module id = BuJs
// module chunks = 2